// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1_U5v","error":"Textarea_error__dcsvt","readonly":"Textarea_readonly__2_Agy","disabled":"Textarea_disabled__3ZMAu"};